module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8453/img/blobsRight.png"